'use client'

import { useRouter } from 'next/navigation';
import Link from 'next/link';


function Collapse({path,title,pageNavdata,params}:any){
    
    
    const router = useRouter();

     function ConcatPath(curPath:any){

        if(!params.slug){
            return false 
        }

        if(path.includes('/about/honor')){

            if(curPath==='/about/honor' && !params?.slug[1]){ 
                return `${curPath}`
            }else if(curPath==='/about/honor/certificateList' && !params?.slug[2]){
                return `${curPath}`
            }else{
                if(params?.slug[1]==="detailId" && params?.slug[2]){
                    return `${curPath}/${params?.slug[1]}/${params?.slug[2]}`
                }else if(params?.slug[2]==="detailId" && params?.slug[3]){
                    return `${curPath}/${params?.slug[2]}/${params?.slug[3]}`
                }else if( params?.slug[1]==='certificateList' && params?.slug[2]){
                    return `${curPath}/${params?.slug[2]}`
                }else{
                    if(params?.slug[1]==='certificateList'){
                        return `${curPath}`
                    }else{
                        return `${curPath}/${params?.slug[1]}`
                    }
                }
            }
        }else{
            return  `${curPath}`
        }

     }


    return(
        <>
            <div className="w-[100vw] h-[5rem] bg-[#f6f6f6] shadow-[inset_1_0_2rem_rgba(0,0,0,.3)] flex justify-between items-center p-7">
                <img onClick={()=>{router.back()}} className="w-[2rem] h-[2rem] block" src="/m_img/return.png" alt="" />
                <span className="text-[1.7rem] text-[#666]">{title}</span>
                {
                    pageNavdata.length>0?<img className="w-[3rem] h-[3.5rem] block hs-collapse-toggle" src="/m_img/more.png" data-hs-collapse="#hs-basic-collapse-heading" alt="" />:<div></div>
                }
              
            </div>
            <div id="hs-basic-collapse-heading" className="bg-[#fff] hs-collapse hidden w-full overflow-hidden transition-[height] duration-300 border-b border-[#e6e6e6] border-solid" aria-labelledby="hs-basic-collapse">
                <div className="mt-5">
                    <ul className="p-4 flex flex-wrap">
                        {
                           pageNavdata.map((item:any,index:number)=>{
                            return <li 
                                    key={item.title} 
                                    style={{background:path===ConcatPath(item.href)?"#1a455d":"",
                                    color:`${path}`===ConcatPath(item.href)? "#fff":""}}  className={`w-[11.2rem]  hover:bg-[#1a455d] hover:text-[#fff] whitespace-nowrap overflow-hidden  text-ellipsis text-[#666] rounded-[4px] border-[1px] border-solid border-[#e6e6e6] ml-[.5rem] text-center leading-[32px] mb-[.5rem] bg-[#f3f3f3]`} ><Link href={`/m`+item.href}>{item.title}</Link>
                                </li>
                                }
                             )
                        } 
                    </ul>   
                </div>
            </div>
        </>
       
        
    )
}

export default Collapse